export default __webpack_public_path__ + "media/we_offer.ef6451a7.png";